<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormBrand v-model="element.brand"/>
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <FormModel v-model="element.model"/>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza termica utile nominale" v-model="element.power_useful" addTitle="(calcolo rcee)" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Potenza termica al focolare nominale" v-model="element.power_nominal" />
    </div>
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Rendimento termico utile a pn max" v-model="element.power_useful_pn" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Matricola" v-model="element.registration" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Camera combustione"
        v-model="element.type2"
        :options="['A aperta', 'C stagna']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Luogo di installazione"
        v-model="element.place_of_installation"
        :options="['Interno', 'Esterno', 'Locale uso esclusivo']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Combustibile"
        v-model="element.fuel"
        :options="['Metano', 'Gpl', 'Butano', 'Biogas', 'Propano', 'Combustibile solido', 'Altro']"
        addTitle="(calcolo rcee)"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Camino"
        v-model="element.chimney"
        :options="['Singolo', 'A parete', 'Collettivo']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Utilizzo"
        v-model="element.usage"
        :options="['ACS', 'Risc', 'Raff']"
        multiple
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Fluido termovettore" v-model="element.fluid" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Marcatura eff energetica"
        v-model="element.eff"
        :options="['⭐', '⭐⭐', '⭐⭐⭐', '⭐⭐⭐⭐', '⭐⭐⭐⭐⭐']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Tiraggio"
        v-model="element.draft"
        :options="['Naturale', 'Forzato']"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Classificazione"
        v-model="element.classification"
        :options="['Standard', 'Condensazione']"
      />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputTextarea name="Note" v-model="element.notes" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: Object
  }
}
</script>